// extracted by mini-css-extract-plugin
module.exports = {"container":"OverduePanel_container__10v82","title":"OverduePanel_title__213Cm","delete":"OverduePanel_delete__2MZ7q"};